import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Toolbar, Avatar, Box, Typography, Select, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { styles } from '../../classes/Styles'

class HomepageHeaderComponent extends React.Component {
  static propTypes = {
    homepage: PropTypes.object,
    topic: PropTypes.object,
    history: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedHomepage: ''
    }
  }

  componentDidMount () {
    if (this.props.topic.details) {
      this.setState({ selectedHomepage: this.props.topic.details.display_name || this.props.topic.details.name })
    }
  }

  changeHomepage = (id, name) => {
    this.setState({ selectedHomepage: name})
    this.props.history.push(`/insights/homepage/${id}`)
  }

  render () {
    const { homepage } = this.props
    let homepageEntities = homepage.details && homepage.details.homepage_entities.sort((a, b) => (a.entity_name < b.entity_name) ? -1 : (a.entity_name > b.entity_name) ? 1 : 0)
    return (
      <AppBar position="static" color="transparent" elevation={0} className="header">
        <Toolbar disableGutters={true} justify="center">
          <Avatar alt="Page title icon" src="/static/images/homepage.png" variant="square" className="titleIcon"></Avatar>
          { (this.props.shortcut || (homepageEntities && homepageEntities.length === 1)) &&
            <Box pl={1} className='shortcutTitle'>
              <Typography>
                <span className="title">{this.state.selectedHomepage}</span>
              </Typography>
            </Box>
          }
          { (!this.props.shortcut && (homepageEntities && homepageEntities.length > 1)) &&
            <Box pl={1}>
              <Select
                value={this.state.selectedHomepage}
                >
                { homepageEntities && homepageEntities.map(entity => {
                  return (
                    <MenuItem value={entity.entity_name} key={entity.entity_id} onClick={() => this.changeHomepage(entity.entity_id, entity.entity_name)}>
                      <span className="title">{entity.entity_name}</span>
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          }
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles)(HomepageHeaderComponent)
